module.exports = __webpack_public_path__ + "static/media/faqImg600.7af38475.jpeg";